import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  DialogTitle,
  Button,
  DialogActions,
  DialogContent,
  TextField,
  Grid,
  LinearProgress
} from '@material-ui/core';

import Dialog from '../Dialog';
import { inputFieldNames, userRoles } from '../../constants';
import FancyDropDown from '../FancyDropDown';
import StringDropDown from '../StringDropDown';
import { courseCategories } from '../../constants';
import config from '../../constants/blob_config.json';
import DocumentListDialog from '../../containers/DocumentListDialog';
import LibraryDocumentList from '../LibraryDocumentList';
import {addDocumentToArray, removeDocumentFromArray} from "../../mappers/libraryDocumentMapper";
import { COURSE_NOTES } from './../../constants/inputFieldNames';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  documentButton: {
    width: '100%'
  },
  footer: {
    background: '#f0f0f0'
  },
  picker: {
    margin: 0,
    padding: 0
  },
  documentLink: {
    display: 'block',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  browseButton: {
    marginTop: '10px'
  }
}));

const CreateEditCourseFormUi = (props) => {
  const {
    openDialog,
    isSaving,
    onHandleInputChange,
    openCreateCourseDialog,
    handleSubmit,
    title,
    course,
    documents,
    canEditDocuments,
    actionButtonText = 'Add',
    openDocumentListDialog,
    onDocumentSelected
  } = props;
  const classes = useStyles();



  const blobDocuments = documents.filter((x) => x.isFolder === false);

  const onDialogClose = () => {
    openCreateCourseDialog(false);
  };

  const onDocumentListDialogOpen = () => {
    openDocumentListDialog(true);
  };

  const handleInputChange = (e, inputfieldName) => {
    if (
      inputfieldName === inputFieldNames.LAST_HELD_DATE ||
      inputfieldName === inputFieldNames.NEXT_EVENT_DATE
    ) {
      onHandleInputChange(e, inputfieldName);
    } else {
      onHandleInputChange(e.target.value, inputfieldName);
    }
  };



  const handleDocumentSelected = (documentLink) => {
    const {document} = course;
    const updatedDocument = addDocumentToArray(document, documentLink);
    onDocumentSelected(updatedDocument);
  };

  const handleDocumentRemove = (documentToRemove) => {
    const {document} = course;
    const updatedDocument = removeDocumentFromArray(document, documentToRemove);
    onDocumentSelected(updatedDocument);
  }

  return (
    <React.Fragment>
       <DocumentListDialog handleDocumentSelected={handleDocumentSelected} showDropdown={true} />
      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        {isSaving ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          {title}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            <Grid container className={classes.formContainer} spacing={3}>
              <Grid item xs={6}>
                <TextField
                  id="unitDescription"
                  label="Unit Description"
                  fullWidth
                  variant="outlined"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.UNIT_DESCRIPTION)
                  }
                  value={course.unitDescription}
                  required={true}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="trainingProvider"
                  label="Training Provider"
                  fullWidth
                  variant="outlined"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.TRAINING_PROVIDER)
                  }
                  value={course.trainingProvider}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  id="courseCost"
                  label="Training Cost (NZD)"
                  fullWidth
                  variant="outlined"
                  inputProps={{ min: 0 }}
                  type="number"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.COURSE_COST)
                  }
                  value={course.courseCost}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="frequency"
                  label="Frequency (in months)"
                  fullWidth
                  variant="outlined"
                  inputProps={{ min: 0 }}
                  type="number"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.FREQUENCY_FOR_COURSE)
                  }
                  value={course.frequency || ''}
                />
              </Grid>
              <Grid item xs={6}>
                {/* EventType */}
                <FancyDropDown
                  htmlId="courseCategory"
                  label="Training Category"
                  margin="normal"
                  value={course.courseCategoryId}
                  handleChange={(e) =>
                    handleInputChange(e, inputFieldNames.COURSE_CATEGORY)
                  }
                  items={courseCategories.courseCategories}
                  dropDownWidth="100%"
                  className={classes.dropDown}
                  valueField="id"
                  displayField="value"
                />
              </Grid>
              <Grid item xs={12} className={classes.multilineTextBox}>
               <TextField
                 id="noteId"
                 label="Notes"
                 multiline
                 rows={3}
                 fullWidth
                 variant="outlined"
                 onChange={(e) => handleInputChange(e, inputFieldNames.COURSE_NOTES)}
                 value={course.notes}
               />
             </Grid>
              {canEditDocuments ? (
                <Grid item xs={9}>
                  <TextField
                    type="text"
                    placeholder="Browse document"
                    defaultValue={course.document}
                    variant="outlined"
                    inputProps={{ readOnly: true }}
                    fullWidth
                    value={course.document}
                  />
              <LibraryDocumentList commeSeperatedDocument = {course.document} onRemoveDocument = {handleDocumentRemove} canEdit={canEditDocuments}/> 
                </Grid>
              ) : (
       /*          <Grid item xs={12}>
                  <a
                    className={classes.documentLink}
                    href={config.documentPrefix + course.document}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {course.document}
                  </a>
                </Grid> */
                <LibraryDocumentList commeSeperatedDocument = {course.document} onRemoveDocument = {handleDocumentRemove} canEdit={canEditDocuments}/> 
              )}
              {canEditDocuments && (
                <Grid item xs={3}>
                  <Button
                    color="primary"
                    variant="contained"
                    className={(classes.documentButton, classes.browseButton)}
                    id="seeDocumentButon"
                    onClick={onDocumentListDialogOpen}
                  >
                    {'Browse'}
                  </Button>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions className={classes.footer}>
            <Button
              onClick={onDialogClose}
              color="primary"
              variant="outlined"
              className={classes.actionButton}
              id="cancelButton"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.actionButton}
              id="addChildButton"
              // disabled={!enableAddButton}
            >
              {actionButtonText}
            </Button>
          </DialogActions>
        </form>
      
      </Dialog>
    
    </React.Fragment>
  );
};

export default CreateEditCourseFormUi;
